// removed by extract-text-webpack-plugin
module.exports = {"component":"_3JJnMBwgyPP77W2nSHzkK4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProductInvoiceAddingItemShowText/ProductInvoiceAddingItemShowText.scss
 ** module id = 1017
 ** module chunks = 0
 **/